export default __webpack_public_path__ + "static/media/no-link.ab65dade.svg";